import { useNavigate } from 'react-router'

import { useUserStore } from '@/stores/app/user'

export const useRouter = () => {
    const navigate = useNavigate()

    const clientName = useUserStore((state) => state.clientName)

    const push = (url: string) => {
        if (!clientName) {
            return navigate(url)
        }

        navigate(`/${clientName}${url}`)
    }

    return {
        push,
    }
}
